import RequestHandler from "./request-handler";
class HeatingTableHeaderService {
    constructor() {
        this.path = "HeatingTableHeader";
        if (HeatingTableHeaderService.instance) {
            return HeatingTableHeaderService.instance;
        }
        HeatingTableHeaderService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async import(data) {
        return await RequestHandler.import(this.path, data);
    }
}
const instance = new HeatingTableHeaderService();
export default instance;